import PropTypes from "prop-types"
import React, { useState, useEffect } from "react"
import { api_base_url, browserstring } from "../../utils/auth"
import { navigate } from "gatsby"
import * as styles from "./main.module.css"
import { useNavigationState } from "../navigation-context"
import { USER_DONATION_RECIPIENT, USER_DONOR, USER_SUBSCRIPTION_RECIPIENT } from "../../utils/constants"

const axios = require('axios').default;

const DonatorBalance = ({ user_name, account_data, credit_data, cookie, onChangeValue, user_type=USER_DONOR, location }) => {

  const [balance, setBalance] = useState(-1)
  const [credit, setCredit] = useState(0)
  const [showDonorAccount, setShowDonorAccount] = useState(true);
  const [headline, setHeadline] = useState("Kontobehållning");
  const [creaditHeadline, setCreditHeadline] = useState("Saldo efter kreditköp");

  const navstate = useNavigationState();

  useEffect(() => {

    console.log("ACCOUNT DATA");
    console.log(account_data);
    if (account_data) {

      console.log("SET BALANCE 1");
      console.log(account_data.Balance);
      setBalance(account_data.Balance)

      if (credit_data !== undefined && credit_data.SEK !== undefined &&
        credit_data.SEK.total !== undefined && credit_data.SEK.total > 0) {

        if (account_data.UserData==="Account_A") {
          const creditedBalance = account_data.Balance - credit_data.SEK.total;

          setCredit(creditedBalance);
        } else {
          setCredit(credit_data.SEK.total);
        }
      }
      setShowDonorAccount(account_data.UserData==="Account_A");

      if (account_data.UserData==="Account_A") {
        setHeadline("Kontobehållning");
        setCreditHeadline("Saldo efter kreditköp");
      } else if (account_data.UserData==="Account_B") {
        setHeadline("Kontobehållning donationer");
        setCreditHeadline("Utestående kreditköp");
      } else if (account_data.UserData==="Account_C") {
        setHeadline("Kontobehållning prenumerationer");
        setCreditHeadline("Utestående kreditköp");
      } else if (account_data.UserData==="Account_D") {
        setHeadline("Kontobehållning köp");
        setCreditHeadline("Utestående kreditköp");
      } else {
        setHeadline("Laddar ditt konto")
        setCreditHeadline("Laddar ditt konto")
      }
    }
     else {
       setShowDonorAccount(user_type === USER_DONOR);
      const options = {
        method: 'post',
        url: `${api_base_url()}/${cookie}/balance`,
        data: {
          BrowserData: browserstring()
        }
      };

      axios(options)
        .then(response => {
          if (user_type === USER_DONOR) {
            setHeadline("Kontobehållning")

            console.log("SET BALANCE 2");
            console.log(response.data.Account_A);
            setBalance(response.data.Account_A);
            if (response.data.Credit.SEK !== undefined &&
            response.data.Credit.SEK.total !== undefined) {
              setCredit(response.data.Account_A - response.data.Credit.SEK.total);
            }

            if (onChangeValue) {
              onChangeValue(response.data.Account_A);
            }
          } else if (user_type === USER_DONATION_RECIPIENT) {
            console.log("SET BALANCE 3");
            console.log(response.data.Account_B);
            setHeadline("Kontobehållning donationer")
            setBalance(response.data.Account_B);
            if (response.data.DonationCredit.SEK !== undefined &&
              response.data.DonationCredit.SEK.total !== undefined) {
              setCredit(response.data.DonationCredit.SEK.total);
            }

            if (onChangeValue) {
              onChangeValue(response.data.Account_B);
            }
          } else if (user_type === USER_SUBSCRIPTION_RECIPIENT) {
            setHeadline("Kontobehållning prenumerationer")
            console.log("SET BALANCE 4");
            console.log(response.data.Account_C);
            setBalance(response.data.Account_C);
            if (response.data.SubscriptionCredit.SEK !== undefined &&
              response.data.SubscriptionCredit.SEK.total !== undefined) {
              setCredit(response.data.SubscriptionCredit.SEK.total);
            }

            if (onChangeValue) {
              onChangeValue(response.data.Account_C);
            }
          }
        });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])


  if (balance < 0) {
    return (<div>Laddar din kontobehållning...
      <div className="spinner-border" role="status">
        <span className="sr-only">Loading...</span>
      </div></div>)
  } else {
    return (
      <div className={["mb-3", styles.outer].join(" ")}>
        <div className={[styles.balancecontainer, "border", "border-light", "rounded"].join(" ")}>
          <div>{headline}</div>
          <div className={styles.buttonContainer}>
            <h2>
              <span className={["badge", "badge-secondary", styles.aligned].join(" ")}>{balance} kr</span>
              <button style={{ display: showDonorAccount ? "inline-block" : "none" }}
                      className={["btn", "btn-info", styles.aligned].join(" ")} onClick={(e) => {
                navigate('/app/refill',{state: { donationpage: navstate.donationpage }})
              }}>Fyll på
              </button>
            </h2>
          </div>
          {credit !== 0 && (
            <div>
              <div>{creaditHeadline}</div>
              <div className={styles.buttonContainer}>
                <h2>
                  <span className={["badge", "badge-danger", styles.aligned].join(" ")}>{credit} kr</span>
                </h2>
              </div>
            </div>)}
        </div>
      </div>
    )
  }
}

DonatorBalance.propTypes = {
  user_name: PropTypes.string,
  account_data: PropTypes.object,
  cookie: PropTypes.string,
  isDonor: PropTypes.bool,
}

DonatorBalance.defaultProps = {
  user_name: ``,
  account_data: {},
  cookie: ``,
  isDonor: true,
}

export default DonatorBalance